import {
  Box,
  Button,
  Skeleton,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import PageSizePaginationFooter from 'shared/components/PageSizePaginationFooter';
import { useResellerContext } from '../ResellerContext';

const ResellerTable = () => {
  const navigate = useNavigate();
  const {
    customers,
    loading,
    total,
    page,
    setPage,
    pageSize,
    setPageSize,
    reportData,
  } = useResellerContext();

  const handleRowClick = (document: string) => {
    navigate(`/customer/${document}`);
  };

  if (loading) {
    return (
      <Stack gap="0.5rem">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} h="3rem" rounded="md" />
        ))}
      </Stack>
    );
  }

  if (!customers.length) {
    return (
      <Text color="gray.500" py={8} textAlign="center">
        Nenhum cliente encontrado.
      </Text>
    );
  }

  return (
    <>
      <TableContainer overflowX="auto">
        <Table variant="detailed" size="sm">
          <Thead>
            <Tr>
              <Th textAlign="left">Documento</Th>
              <Th textAlign="left">Nome Fantasia</Th>
              <Th textAlign="left">Razão Social</Th>
              <Th textAlign="left">Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {customers.map((customer) => (
              <Tr
                key={customer.id}
                _hover={{ bg: 'gray.50', cursor: 'pointer' }}
                onClick={() => handleRowClick(customer.cnpj)}
              >
                <Td>{customer.cnpj}</Td>
                <Td>{customer.trade_name}</Td>
                <Td>{customer.name}</Td>
                <Td>
                  <Button
                    size="xs"
                    colorScheme="yooga"
                    variant="outline"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRowClick(customer.cnpj);
                    }}
                  >
                    Acessar
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>

      <Box pt={4}>
        <PageSizePaginationFooter
          totalLength={total}
          visibleLength={customers.length}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          disabled={loading}
          pageSizes={[10, 20, 30, 50]}
        />
      </Box>

      {reportData && (
        <Box pt={2} display="flex" justifyContent="flex-end">
          <Text fontSize="sm" color="gray.500">
            Total de IDIs ativos:{' '}
            <Text as="span" fontWeight="bold" color="yooga.500">
              {reportData.idis.total}
            </Text>
          </Text>
        </Box>
      )}
    </>
  );
};

export default ResellerTable;
